import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import type { ReactElement } from "react";

export function CasaviSettingsSkeleton(): ReactElement {
  return (
    <Card>
      <CardContent className="space-y-6">
        {/* Application selector */}
        <div className="flex items-center justify-between gap-4">
          <div className="min-w-0 space-y-1">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-3 w-56" />
          </div>
          <Skeleton className="h-9 w-64 shrink-0" />
        </div>

        {/* Cron enabled toggle */}
        <div className="flex items-center justify-between gap-4">
          <div className="min-w-0 space-y-1">
            <Skeleton className="h-4 w-28" />
            <Skeleton className="h-3 w-64" />
          </div>
          <Skeleton className="h-6 w-10 shrink-0 rounded-full" />
        </div>

        {/* Cron schedule picker */}
        <div className="flex items-center justify-between gap-4">
          <div className="min-w-0 space-y-1">
            <Skeleton className="h-4 w-28" />
            <Skeleton className="h-3 w-60" />
          </div>
          <Skeleton className="h-9 w-52 shrink-0" />
        </div>

        {/* Run on startup toggle */}
        <div className="flex items-center justify-between gap-4">
          <div className="min-w-0 space-y-1">
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-3 w-64" />
          </div>
          <Skeleton className="h-6 w-10 shrink-0 rounded-full" />
        </div>

        {/* Dry run toggle */}
        <div className="flex items-center justify-between gap-4">
          <div className="min-w-0 space-y-1">
            <Skeleton className="h-4 w-16" />
            <Skeleton className="h-3 w-52" />
          </div>
          <Skeleton className="h-6 w-10 shrink-0 rounded-full" />
        </div>
      </CardContent>
    </Card>
  );
}
